import { CloudPrice, PriceIncludingWildMembership } from '@/shared/types/prices';

export const cloudPriceToPriceIncludingWildMembershipPrices = (
  prices: CloudPrice[],
  isMember: boolean = false,
  isBuy: boolean = true,
): PriceIncludingWildMembership[] => {
  if (!Array.isArray(prices) || prices.length === 0) {
    return [];
  }

  const priceData: PriceIncludingWildMembership[] = [];

  const retailsPriceOrderCode = isBuy ? 'msrp' : 'rentmsrp';
  const wildPriceOrderCode = isBuy ? 'wmp' : 'rentwild';
  const standardPriceOrderCode = isBuy ? 'std' : 'rentstd';

  const retailPrice = prices.find((p) => p.type === retailsPriceOrderCode);
  const standardPrice = prices.find((p) => p.type === standardPriceOrderCode);
  const memberPrice = prices.find((p) => p.type === wildPriceOrderCode);

  const retail: PriceIncludingWildMembership = {
    type: 'retail',
    value: retailPrice?.value ?? 0,
    currencyCode: retailPrice?.currencyCode ?? 'USD',
  };

  const standard: PriceIncludingWildMembership = {
    type: 'price',
    value: standardPrice?.value ?? 0,
    currencyCode: standardPrice?.currencyCode ?? 'USD',
  };

  const member: PriceIncludingWildMembership = {
    type: 'member',
    value: memberPrice?.value ?? 0,
    currencyCode: memberPrice?.currencyCode ?? 'USD',
  };

  const current = isMember ? member : standard;

  const isSale =
    standard.value > 0 &&
    retail.value > 0 &&
    standard.value < retail.value &&
    standard.value <= member.value;

  const sale: PriceIncludingWildMembership | null = isSale
    ? {
        type: 'sale',
        value: current.value,
        previousValue: retail.value,
        currencyCode: current.currencyCode,
      }
    : null;

  const currentPrice: PriceIncludingWildMembership = {
    type: 'current',
    value: current.value,
    currencyCode: current.currencyCode,
  };

  priceData.push(retail, standard, member, currentPrice);
  if (sale) priceData.push(sale);

  return priceData;
};
